import {call} from 'redux-saga/effects';
import {getLikeData, getPurchasedData, getRecentData} from './apiGet';
import {MY_PAGE_LIMIT} from './saga';
import callApi from '../../../common/util/api';
import {IMyPageSecondTab} from '../type';

export function* callApiMyPageTabPayload({
  tab,
  sort,
  offset,
  isEdit,
}: {
  tab: IMyPageSecondTab;
  offset?: number;
  sort?: string;
  isEdit?: boolean;
}) {
  const isRecentTab = tab === 'recent';
  const isPurchaseTab = tab === 'own';
  const isLikeTab = tab === 'like';
  const {data, success, meta} = yield call(callApi, {
    url: MY_PAGE_FETCH_LIST_URL_V4[tab](isEdit),
    params:
      tab === 'recent'
        ? {sort, offset, limit: 100}
        : {sort, offset, limit: MY_PAGE_LIMIT},
  });
  let recent;
  let own;
  let like;
  if (data && success && meta) {
    if (isRecentTab) {
      recent = getRecentData({data, meta});
    }
    if (isPurchaseTab) {
      own = getPurchasedData({
        data,
        meta,
        isEdit,
      });
    }
    if (isLikeTab) {
      like = getLikeData(data, meta);
    }
  }
  return {success, recent, own, like};
}

export function callApiMyPageDelete(tab: IMyPageSecondTab, ids: number[]) {
  return call(callApi, {
    method: tab === 'own' ? 'POST' : 'DELETE',
    url: MY_PAGE_DELETE_LIST_URL_V4[tab],
    data: tab === 'like' ? {contentIds: ids} : ids,
  });
}

const MY_PAGE_FETCH_LIST_URL_V4: {
  [key in IMyPageSecondTab]: (isEdit?: boolean) => string;
} = {
  recent: () => '/history/v2/views/recent-read-content',
  own: isEdit => `/history/v2/views/purchased-content${isEdit ? '/edit' : ''}`,
  like: () => '/popularity/v4/subscriptions',
};

const MY_PAGE_DELETE_LIST_URL_V4 = {
  recent: '/history/v2/recent-read-contents',
  own: '',
  like: '/popularity/v2/subscriptions/unsubscribe',
};
